import { useFormikContext } from 'formik';
import React  from 'react';
import { Route } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import { useAuth } from '../../Services/AuthContext';
import entities from '../../utils/entities';
import ClientDetailsCard from '../Cards/ClientDetailsCard';
import ClientModal from '../Models/ClientModal';

import FlightRoute from './FlightRoute';

const CharterShare = ({ route, purchase }) => {
    const { values } = useFormikContext();
    const [auth] = useAuth();
    const { id } = values;
   
    return <Container>
         <Row>
            {auth.role !== 'Supplier' ? <ClientDetailsCard route={route} charterDetails={values} /> : null}
        </Row>
        <Row>
            <FlightRoute route={route + '/' + id} purchase={purchase} share values={values} noEdit />
        </Row>
        <Route path={route + '/' + id+'/:id'}
            render={({ match }) =>
                <ClientModal entity={entities.charterSharePurchase} route={route + '/' + id} itemParam='id'/>} />
        </Container>
        
}
export default CharterShare;  